

<template>
  <v-container fluid  fill-height class="d-block">
        <v-card class="elevation-12 login-dialog"
                :class="$vuetify.breakpoint.name">
          <v-card-text class="my-12">
            <v-row align="center" justify="center" class="my-5">
              <span><v-img
                  class="display-2 teal--text text--accent-3"
                  src="../assets/favicon.png"
                  height="70"
                  width="80"
                  contain/></span>
              <span style="font-weight: 600; font-size: large">ABC Maintenance</span>
            </v-row>
            <v-container fluid>
              <v-row no-gutters>
                <v-col sm="8" offset-sm="2">
                  <v-form @submit="handleLogin">
                    <p class="my-20">
                      <label
                        class="alertText"
                        v-if="authenticationFailed === true">{{ $t('common.errors.loginFailed') }}</label>
                      <label class="alertText" v-if="isNetworkError === true">{{$t('common.errors.networkError')}}</label>
                      <label class="alertText" v-if="isForbidden === true">{{$t('common.errors.accessForbidden')}}</label>
                    </p>
                    <p v-for="(error, i) in errors" :key="i" class="alertText">
                      {{ $t(error) }}
                    </p>
                    <!--' ' placeholders to counter chrome/vuetify bug where label and prefilled username are over each others-->
                    <v-text-field
                      v-model="username"
                      ref="username"
                      v-bind:label="$t('common.username')"
                      name="username"
                      type="text"
                      outlined
                      color="primary"
                      :placeholder="' '"
                      :class="autofill ? 'autofill' : ''"
                    />
                    <v-text-field
                      v-model="password"
                      ref="password"
                      v-bind:label="$t('common.password')"
                      name="password"
                      type="password"
                      outlined
                      color="primary"
                      :placeholder="' '"
                      :class="autofill ? 'autofill' : ''"
                    />
                    <div v-if="loading" class="text-center">
                      <Spinner style="margin-bottom: 1.75rem" />
                    </div>
                    <div v-else class="text-center mt-3">
                      <v-btn tile color="primary" type="submit">
                        {{ $t('common.logIn') }}
                      </v-btn>
                    </div>
                  </v-form>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
  </v-container>
</template>

<style scoped>
.alertText {
  color: red;
}

.autofill >>> .v-label {
  transform: translateY(-18px) scale(0.75);
}

.login-dialog {

  margin-right: auto;
  margin-left: auto;
  max-width: 30em;
}

</style>
<script>
import { Vue } from 'vue-property-decorator';
import Spinner from 'vue-simple-spinner';

export default Vue.extend({
  name: 'Login',
  components: {
    Spinner,
  },
  data() {
    return {
      loading: false,
      errors: [],
      password: '',
      username: '',
      browserLanguage: 'en-GB',
      authenticationFailed: false,
      isNetworkError: false,
      isForbidden: false,
      autofill: false,
      intervalDetectAutofill: null,
    };
  },

  computed: {
    loggedIn() {
      return window.$cookies.get('Authorization') ? true : false;
    },
    user() {
      return { username: this.username, password: this.password };
    },
    redirectToRoute() {
      return this.$store.state.uiStatus.redirectRouteAfterLogin;
    },
    redirectToUrl() {
      return this.$store.state.uiStatus.redirectUrlAfterLogin;
    },
  },

  created() {
    if (
      this.loggedIn &&
      !(this.isNetworkError || this.isForbidden || this.authenticationFailed)
    ) {
      if (this.redirectToRoute) {
        this.$router.push(this.redirectToRoute);
      } else if (this.redirectToUrl) {
        window.location.href = this.redirectToUrl;
      } else {
        //Sooo not the correct way to do this, but I don't have time to redo everything
        window.location.href = this.$router.resolve('/status').href;
      }
    }
  },

  mounted() {
    // search for autofill every 100ms
    this.intervalDetectAutofill = setInterval(() => {
      if (
        document.querySelectorAll('input[type="password"]:-webkit-autofill')
          .length > 0
      ) {
        this.autofill = true;
      }
    }, 100);

    // clean interval if needed after 3s
    setTimeout(() => {
      if (this.intervalDetectAutofill) {
        clearInterval(this.intervalDetectAutofill);
        this.intervalDetectAutofill = null;
      }
    }, 3000);
  },

  watch: {
    username() {
      this.autofill = false;
    },
    password() {
      this.autofill = false;
    },
    autofill() {
      // clean interval if autofill detected or user input
      if (this.intervalDetectAutofill) {
        clearInterval(this.intervalDetectAutofill);
        this.intervalDetectAutofill = null;
      }
    },
  },

  methods: {
    validateForm() {
      this.errors = [];
      if (this.username && this.password) return true;
      if (!this.username) this.errors.push('common.errors.emptyUsername');
      if (!this.password) this.errors.push('common.errors.emptyPassword');
    },

    async handleLogin(event) {
      event.preventDefault();
      this.authenticationFailed = false;
      this.isNetworkError = false;
      this.isForbidden = false;
      this.loading = true;
      if (this.validateForm()) {
        try {
          await this.$store.dispatch('auth/login', this.user);
          if (this.redirectToRoute) {
            await this.$store.dispatch('user/getUser');
            await this.$store.dispatch('userSessionStateStore/update');
            await this.$store.dispatch('corporationSettingsState/update');
          }
        } catch (error) {
          const status = error.response?.status;
          if (status === 401) {
            this.authenticationFailed = true;
          } else if (status === 403) {
            this.isForbidden = true;
          } else {
            this.isNetworkError = true;
          }
          this.loading = false;
        }
        if (
          !(
            this.authenticationFailed ||
            this.isNetworkError ||
            this.isForbidden
          )
        ) {
          if (this.redirectToRoute) {
            this.$router.push(this.redirectToRoute);
          } else if (this.redirectToUrl) {
            window.location.href = this.redirectToUrl;
          } else {
            //Sooo not the correct way to do this, but I don't have time to redo everything
            //window.location.href = this.$router.resolve('/status').href;
            //console.log(process.env);
            window.location.href = `${process.env.VUE_APP_HTTP}${process.env.VUE_APP_UI_ADDRESS}`;
          }
        }
      }
    },
  },
});
</script>
